import React from "react";
import { Link } from "react-router-dom";

export default function AccountPagesHeader(props) {
  return (
    <nav className="navbar navbar-expand-lg bg-transparent">
      <div className="container-fluid app-container navbar-cover account-navbar d-flex">
        {/* Logo Start*/}
        <Link to="/" className="navbar-brand">
          Hotelbnb
        </Link>
        {/* Logo End*/}

        {/* Accout Status Start */}
        <div className="col-auto" id="navbarSupportedContent">
          <p className="ms-auto m-0 p-0 text-center">{props.status}</p>
        </div>
        {/* Accout Status End */}
      </div>
    </nav>
  );
}
